import React from 'react'
import useChromeStyles from 'pages/schedule/SelectLessonTime/redesign/styles'
import {
  SchedulePageSkeletonFrame,
  SkeletonBlock,
  SkeletonText,
  YourTimeSkeleton,
} from 'pages/schedule/SelectLessonTime/redesign/skeleton-parts'
import useStyles from './styles'

// Placeholder for the redesigned step 3 while the lesson type, student and
// feature flags load. Same frame as the loaded page (grey background, back row
// or compact summary, "Your time" card, payment card, summary column on
// desktop, sticky action bar when compact) so nothing shifts.
const ReviewSkeletonRedesign = () => {
  const chrome = useChromeStyles()
  const classes = useStyles()
  return (
    <SchedulePageSkeletonFrame testId="review-booking-skeleton">
      {({ isCompact }) => (
        <div className={classes.stack}>
          <YourTimeSkeleton className={classes.yourTime} />
          <div className={classes.payCard} aria-busy="true">
            <SkeletonBlock height={64} radius={16} />
            <SkeletonText width="35%" height={36} style={{ marginTop: 24 }} />
            <SkeletonText height={24} style={{ marginTop: 8 }} />
            <SkeletonText height={24} />
            <SkeletonText width="50%" height={32} style={{ marginTop: 8 }} />
            {!isCompact && (
              <SkeletonBlock
                height={48}
                radius={24}
                style={{ marginTop: 24 }}
              />
            )}
          </div>
          {isCompact && (
            <div className={chrome.bottomBar}>
              <SkeletonText width="35%" height={21} />
              <SkeletonBlock width={140} height={44} radius={22} />
            </div>
          )}
        </div>
      )}
    </SchedulePageSkeletonFrame>
  )
}

export default ReviewSkeletonRedesign
